export default __webpack_public_path__ + "static/media/ticket26.ac71e25e.jpg";